let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    $('.apo-custom-add-charge.avp-option .avp-paragraph p').append("+15€");
    $('.apo-custom-add-charge.avp-option .avp-paragraph p').css("display", "flex");
    $('.apo-custom-add-charge.avp-option .avp-paragraph p').css("justify-content", "space-between");
    clearInterval(interval);
  }
}, 100);

let interval3 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    let optionMonneys = $('#avpoptions-container__v2 option span.money')
  
    for (let key of optionMonneys) {
      key.innerHTML = ""
    }
    clearInterval(interval3);
  }
}, 100);

function blockNumberKeyInput(event) {
    if (event.key >= '0' && event.key <= '9') {
        event.preventDefault();
    }
}

let interval4 = setInterval(function () {
  let apElements = document.querySelector('.avpoptions-container__v2');
  if (apElements){
    const inputs = document.querySelectorAll(".ap-options__text input[type=text]");
    // inputs.forEach(input => {
    //   input.value = input.value.replace(/[0-9]/g, '');
    // });
    inputs.forEach(input => {
      if (!input.hasAttribute("data-blocked")) {
          input.addEventListener("keydown", blockNumberKeyInput);
          input.setAttribute("data-blocked", "true");
      }
    });
  }
}, 100);

// function addNumberBlockWithInterval() {
//     const inputs = document.querySelectorAll(".no-number-input");
//     setInterval(() => {
//         inputs.forEach(input => {
//           if (!input.hasAttribute("data-blocked")) {
//               input.addEventListener("keydown", blockNumberKeyInput);
//               input.setAttribute("data-blocked", "true");
//           }
//         });
//     }, 500);
// }
// addNumberBlockWithInterval();